export default "/images/security_badge.webp"